import React from "react";
import { RenderKilogramo } from "../../../../Utils/renderField/renderReadField";
import NullableValue from "../../../../Utils/renderField/nullableValue";

export const ProductosTable = ({ trasladoDetalle }) => {
    const trasladoDetalles =
        trasladoDetalle && trasladoDetalle.detalles
            ? trasladoDetalle.detalles
            : [];

    return (
        <div className="new-table-wrapper boleta-traslado__table-wrapper">
            <table className="table-striped">
                <thead>
                    <tr>
                        <th>RECEPCIONES</th>
                        <th>FECHAS</th>
                        <th>KILOS HÚMEDOS</th>
                        {/* KILOS SECOS LAB */}
                        <th>KILOS SECOS</th>
                    </tr>
                </thead>
                <tbody>
                    {trasladoDetalles.map((item) => {
                            return (
                                <tr key={item.id}>
                                    <td className="text-center boleta-traslado__ids-cell">
                                        {item.ingresos_ids_concat}
                                    </td>
                                    <td className="text-center text-nowrap">
                                        {item.rango_fechas}
                                    </td>
                                    <td className="text-center text-nowrap">
                                        <NullableValue
                                            value={item.kilos_humedos}
                                        >
                                            <RenderKilogramo
                                                value={item.kilos_humedos}
                                                decimalScale={2}
                                            />
                                        </NullableValue>
                                    </td>
                                    {/* KILOS SECOS LAB */}
                                    <td className="text-center text-nowrap">
                                        <NullableValue
                                            value={item.kilos_secos_laboratorio}
                                        >
                                            <RenderKilogramo
                                                value={
                                                    item.kilos_secos_laboratorio
                                                }
                                                decimalScale={3}
                                            />
                                        </NullableValue>
                                    </td>
                                </tr>
                            );
                        })}
                </tbody>
            </table>
        </div>
    );
};
